(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["gn-pdp-tabs"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('gn-pdp-tabs')){
customElements.define('gn-pdp-tabs',class extends HTMLElement{
  connectedCallback(){
    if(this.bound)return;this.bound=true;
    this.tabs=[...this.querySelectorAll('.gn-tabs__tab')];
    this.panels=[...this.querySelectorAll('.gn-tabs__panel')];
    this.addEventListener('click',e=>{const t=e.target.closest('.gn-tabs__tab');if(t)this.activate(this.tabs.indexOf(t));});
    this.addEventListener('keydown',e=>{
      if(!e.target.classList||!e.target.classList.contains('gn-tabs__tab'))return;
      const i=this.tabs.indexOf(e.target);let n=null;
      if(e.key==='ArrowRight')n=(i+1)%this.tabs.length;
      if(e.key==='ArrowLeft')n=(i-1+this.tabs.length)%this.tabs.length;
      if(n!==null){e.preventDefault();this.activate(n);this.tabs[n].focus();}
    });
  }
  activate(i){
    if(i<0)return;
    this.tabs.forEach((t,idx)=>{const on=idx===i;t.classList.toggle('is-active',on);t.setAttribute('aria-selected',on?'true':'false');t.tabIndex=on?0:-1;});
    this.panels.forEach((p,idx)=>{const on=idx===i;p.classList.toggle('is-active',on);p.hidden=!on;});
  }
});
}
/* Subscription widget: show the one-time price as a crossed-out compare price
   next to the discounted subscription price. Kept in sync on variant/plan change. */
(function(){
  function enhance(widget){
    /* Cross-out compare price — scoped to each variant's own .plan_card so the
       1-pack card doesn't borrow the 8-pack price. */
    widget.querySelectorAll('.in_widget_price.allocation_price').forEach(function(p){
      const scope=p.closest('.plan_card')||widget;
      const full=(scope.querySelector('.in_widget_price:not(.allocation_price)')||{}).textContent;
      const fullT=full?full.trim():'';
      const disc=p.textContent.trim();
      /* keep compare + discounted together so they wrap as one unit on mobile */
      let grp=p.closest('.gn-price-group');
      if(!grp){grp=document.createElement('span');grp.className='gn-price-group';p.parentElement.insertBefore(grp,p);grp.appendChild(p);}
      let s=grp.querySelector('.gn-sub-compare');
      if(fullT&&fullT!==disc){
        if(!s){s=document.createElement('s');s.className='gn-sub-compare';grp.insertBefore(s,p);}
        if(s.textContent!==fullT)s.textContent=fullT;
      } else if(s){s.remove();}
    });
    /* Move the "Auto-renews…" policy inside the Subscribe card, below the dropdown. */
    widget.querySelectorAll('.shopify_subscriptions_app_policy').forEach(function(pol){
      if(pol.dataset.gnMoved)return;
      const fs=pol.closest('.shopify_subscriptions_fieldset')||widget;
      const dd=fs.querySelector('.group_dropdown');
      const grp=dd?dd.closest('.subscription_group'):null;
      if(grp){grp.appendChild(pol);pol.dataset.gnMoved='1';}
    });
  }
  function init(){
    const widget=document.querySelector('[id*="subscriptions_app_block"]');
    if(!widget)return;
    let obs;
    const run=function(){ if(obs)obs.disconnect(); try{enhance(widget);}catch(e){} if(obs)obs.observe(widget,{childList:true,subtree:true,characterData:true}); };
    obs=new MutationObserver(run);
    run();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
/* Append the selected variant name to the product title, like the US store
   ("BUTTER ON GUMS TOOTHBRUSH – 1 PACK"). Title is a dynamic source so this
   can't be done in Liquid; update the h1 on load + on variant change. */
(function(){
  function titleEl(){return document.querySelector('.product-details h1')||document.querySelector('[class*="product-details"] h1')||document.querySelector('product-information h1');}
  function suffix(){
    const picker=document.querySelector('.variant-picker');if(!picker)return '';
    const vals=[];
    picker.querySelectorAll('input[type="radio"]:checked').forEach(function(r){if(r.value)vals.push(r.value.trim());});
    picker.querySelectorAll('select').forEach(function(s){if(s.value)vals.push(s.value.trim());});
    return vals.filter(function(v){return v && !/^default title$/i.test(v);}).join(' / ');
  }
  function update(){
    const h1=titleEl();if(!h1)return;
    if(!h1.dataset.gnBase)h1.dataset.gnBase=h1.textContent.replace(/\s+/g,' ').trim();
    const suf=suffix();
    const next=suf?(h1.dataset.gnBase+' – '+suf):h1.dataset.gnBase;
    if(h1.textContent.trim()!==next)h1.textContent=next;
  }
  function init(){
    update();
    document.addEventListener('change',function(e){if(e.target&&e.target.closest&&e.target.closest('.variant-picker'))update();});
    const picker=document.querySelector('.variant-picker');
    if(picker){new MutationObserver(update).observe(picker,{subtree:true,attributes:true,attributeFilter:['checked','aria-checked','class'],childList:true});}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
  } catch(e) { console.error(e); }
})();

})();
